import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qat8n5mmyf: FaireBrandEntity = {
  token: "b_qat8n5mmyf",
  type: "brand",
  name: "Willow & Ivy Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/6af62a572172c392d42fab5e4b3dda0cfb8106f4ba046f0e2b54aa518ef83a7d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f8348deba04fd5e0e0aed2d5a148a721eb208120318996f99ed20887fb309151.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6af62a572172c392d42fab5e4b3dda0cfb8106f4ba046f0e2b54aa518ef83a7d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f8348deba04fd5e0e0aed2d5a148a721eb208120318996f99ed20887fb309151.jpeg",
  location: "Mead, CO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 13,
  isInsider: true,
  description:
    "Willow & Ivy Press started with a simple mission: to create stylishly cool greeting cards that deserve a spotlight on your shelf. \n\nOur playful and polished greetings are printed on heavy paper stock and finished with foil and glitter details that let our cards shine every time you gift and receive them. Every card is made in the USA with responsibly sourced materials and arrives with an elegant, gold pearlized envelope that delivers a timeless look and touch. \n\nInterested in carrying Willow & Ivy Press in your store? Our personal service, in-house fulfillment, and eye-catching product remove the guesswork from selling Willow & Ivy Press. Let us do the work so you don't have to: \n\nBeautiful and well-made products sell themselves! Our American-made greeting cards are available in a range of everyday and seasonal occasions that appeal to today's modern shopper. \nWe offer a range of displays to provide the best fit for your store. Whether you're looking for a compact countertop or an elegant floor display — we've got you covered.\nReliable service, both in-store and remote. Our in-house Customer Service and Fulfillment teams allow us to promptly support our retailers with a personal touch. Call centers? Never heard of 'em!  \n\nWe're confident your customers will love our cards as much as we do!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:46.911Z",
    importedBy: "entity-db-cli",
  },
};
